// libraries.
import { Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';

// selectors.
import { getEmail } from '@domains/user/store/slices/user-slice/user-slice';

// utils.
import { TaskItem } from '@domains/documents-review/interfaces/interfaces';

export const PendingTasks = ({ tasks }: { tasks: TaskItem[] }) => {
  const email = useSelector(getEmail);

  const pendingGlobal = tasks.filter(task => task.action === 'pending');
  const pendingByUser = pendingGlobal.filter(task => task.agent === email);

  return (
    <div className="wrapper-tasks">
      <div className="d-flex justify-content-between align-items-center p-3">
        <div className="d-flex gap-3 align-items-center">
          <div className="d-flex gap-2 align-items-center">
            <strong className="fw-bold">Tareas sin completar</strong>
            <Badge className="tasks">{pendingGlobal.length}</Badge>
          </div>
          <div className="d-flex gap-2 align-items-center">
            <strong className="fw-bold">Mis tareas</strong>
            <Badge className="tasks">{pendingByUser.length}</Badge>
          </div>
        </div>
      </div>
    </div>
  );
};
